import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import { SUMMARIZE_STATES, AIMS_STATUS } from "../../../../constants";
import SummarizingIndicator from "./SummarizingIndicator";
import SummarizeStopped from "./SummarizeStopped";
import SummaryReady from "./SummaryReady";
import OrganizerOnlyIndicator from "./OrganizerOnlyIndicator";
import SummarizeRestarting from "./SummarizeRestarting";

/**
 * Unified indicator component that handles all different states of the summarization process
 * This component consolidates the rendering logic for different summarize states into one place
 */
const SummarizeBoxIndicator = ({
  summarizeState,
  rtmsRequesterName,
  hasOutlookWarning,
  aimsStatus,
  role,
  summaryReviewers,
  alias,
  aimsUuid,
  summaryData,
  rtmsStreamId,
  meetingUuid,
  meetingId,
  onViewSummary,
  isRtmsStartedByOther,
  isRestarting,
  hasGermanyAttendee
}) => {
  return (
    <>
      {/* LOADING state when summarization is being restarted due to rtms error */}
      {summarizeState === SUMMARIZE_STATES.LOADING && isRestarting && (
        <SummarizeRestarting />
      )}

      {/* REJECTED state - someone else is starting summary */}
      {summarizeState === SUMMARIZE_STATES.REJECTED && rtmsRequesterName && (
        <>
          <Column height="16px"/>
          <Row width="100%" spacing="none" spacingInset="none">
            <Column width="72px"/>
            <Column spacing="none">
              <Row alignmentHorizontal="start">
                <Text type="h50" color="secondary">
                  {rtmsRequesterName}
                </Text>
              </Row>
              <Row alignmentHorizontal="start">
                <Text type="b200" color="secondary">
                  is turning on meeting summary
                </Text>
              </Row>
            </Column>
          </Row>
        </>
      )}

      {/* DEFAULT state when aimsStatus is summary to organizer */}
      {summarizeState === SUMMARIZE_STATES.DEFAULT && aimsStatus === AIMS_STATUS.SUMMARY_TO_ORGANIZER && (
        <>
          <Column height="16px"/>
          <OrganizerOnlyIndicator />
        </>
      )}

      {/* STOPPED state - summary has ended */}
      {summarizeState === SUMMARIZE_STATES.STOPPED && (
        <SummarizeStopped 
          aimsStatus={aimsStatus} 
          role={role} 
          summaryReviewers={summaryReviewers}
          alias={alias}
          rtmsRequesterName={rtmsRequesterName}
        />
      )}

      {/* READY state - summary is ready to view */}
      {summarizeState === SUMMARIZE_STATES.READY && (
        <SummaryReady 
          aimsUuid={aimsUuid} 
          onViewSummary={onViewSummary}
        />
      )}

      {/* SUMMARIZING state - actively summarizing */}
      {summarizeState === SUMMARIZE_STATES.SUMMARIZING && (
        <SummarizingIndicator 
          rtmsRequesterName={rtmsRequesterName} 
          isRtmsStartedByOther={isRtmsStartedByOther}
          alias={alias}
          rtmsStreamId={rtmsStreamId}
          meetingUuid={meetingUuid}
          meetingId={meetingId}
          aimsStatus={aimsStatus}
          hasGermanyAttendee={hasGermanyAttendee}
        />
      )}
    </>
  );
};

export default SummarizeBoxIndicator;
